export default "__VITE_ASSET__CUpBE1LU__"